const HALO_STEP = 2;
const HEX_RE = /^#[0-9a-f]{6}$/i;

function withAlpha(hex, alpha) {
    // hex is '#rrggbb'; return 'rgba(r, g, b, alpha)'.
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function drawRemoteHalos(ctx, members, geometry) {
    if (!members || !geometry) return;

    const drawable = members
        .filter((m) => (
            m && m.user && m.selection
            && typeof m.user.color === 'string'
            && HEX_RE.test(m.user.color)
        ))
        .sort((a, b) => {
            if (a.user.id < b.user.id) return -1;
            if (a.user.id > b.user.id) return 1;
            return 0;
        });

    drawable.forEach((m, idx) => {
        const offset = (idx + 1) * HALO_STEP;
        const color = m.user.color;
        const sel = m.selection;

        ctx.save();
        ctx.strokeStyle = color;
        ctx.lineWidth = 2;

        // Support both new format (focusedIds) and legacy format.
        const focusedIds = sel.focusedIds ?? null;

        if (focusedIds) {
            // New format: flat array of all selected IDs.
            for (const id of focusedIds) {
                const elGeom = geometry.elements?.[id];
                if (elGeom) {
                    ctx.strokeRect(
                        elGeom.x - offset, elGeom.y - offset,
                        elGeom.width + offset * 2, elGeom.height + offset * 2
                    );
                    continue;
                }
                const areaGeom = geometry.areas?.[id];
                if (areaGeom) {
                    ctx.strokeRect(
                        areaGeom.x - offset, areaGeom.y - offset,
                        areaGeom.width + offset * 2, areaGeom.height + offset * 2
                    );
                    continue;
                }
                const linePath = geometry.lines?.[id];
                if (linePath && linePath.length > 0) {
                    ctx.lineWidth = 2 + (drawable.length - 1 - idx) * 2;
                    ctx.beginPath();
                    linePath.forEach(({ x, y }, i) => {
                        if (i === 0) ctx.moveTo(x, y);
                        else ctx.lineTo(x, y);
                    });
                    ctx.stroke();
                    ctx.lineWidth = 2;
                }
            }
        } else {
            // Legacy format: separate element/line/area/group fields.
            for (const elId of sel.elementIds || []) {
                const b = geometry.elements?.[elId];
                if (b) ctx.strokeRect(b.x - offset, b.y - offset, b.width + offset * 2, b.height + offset * 2);
            }
            for (const elId of sel.groupElementsIds || []) {
                const b = geometry.elements?.[elId];
                if (b) ctx.strokeRect(b.x - offset, b.y - offset, b.width + offset * 2, b.height + offset * 2);
            }
            if (sel.areaId) {
                const b = geometry.areas?.[sel.areaId];
                if (b) ctx.strokeRect(b.x - offset, b.y - offset, b.width + offset * 2, b.height + offset * 2);
            }
            for (const arId of sel.groupAreasIds || []) {
                const b = geometry.areas?.[arId];
                if (b) ctx.strokeRect(b.x - offset, b.y - offset, b.width + offset * 2, b.height + offset * 2);
            }
            if (sel.lineId) {
                const path = geometry.lines?.[sel.lineId];
                if (path && path.length > 0) {
                    ctx.lineWidth = 2 + (drawable.length - 1 - idx) * 2;
                    ctx.beginPath();
                    path.forEach(({ x, y }, i) => {
                        if (i === 0) ctx.moveTo(x, y);
                        else ctx.lineTo(x, y);
                    });
                    ctx.stroke();
                }
            }
        }

        if (sel.insideElement) {
            const { elementId, insideElementId } = sel.insideElement;
            const b = geometry.columns?.[elementId]?.[insideElementId];
            if (b) {
                ctx.fillStyle = withAlpha(color, 0.25);
                ctx.fillRect(b.x, b.y, b.width, b.height);
            }
        }

        ctx.restore();
    });
}
